import React, { useEffect, useState } from "react";
import axios from "axios";
const baseURL = process.env.REACT_APP_BASE_URL;

const Subcatgoryview = () => {
  const [details, setDetails] = useState([]);
  const [editId, setEditId] = useState(null);
  const [formData, setFormData] = useState({ skill_id: "", course: "" });

  const fetchDetails = async () => {
    try {
      const res = await axios.get(`${baseURL}/api/skill-details`);
      setDetails(res.data);
    } catch (err) {
      console.error("Error fetching skill details", err);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this?")) {
      try {
        await axios.delete(`${baseURL}/api/skill-details/${id}`);
        fetchDetails();
      } catch (err) {
        console.error("Error deleting skill detail", err);
      }
    }
  };

  const handleEdit = (item) => {
    setEditId(item.id);
    setFormData({ skill_id: item.skill_id, course: item.course });
  };

  const handleUpdate = async () => {
    console.log("Form Data being sent:", formData); // 👈 add this

    try {
      await axios.put(`${baseURL}/api/skill-details/${editId}`, {
        skill_id: formData.skill_id,
        course: formData.course,
      });
      console.log("Edit ID being sent:", editId);

      setEditId(null);
      setFormData({ skill_id: "", course: "" });
      fetchDetails();
    } catch (err) {
      console.error("Error updating skill detail", err.response?.data || err);
      alert("Failed to update. Please check backend or data format.");
    }
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <h2>Subcategory View (Skill Details)</h2>

      <table
        border="1"
        cellPadding="10"
        cellSpacing="0"
        style={{ width: "100%", marginTop: "20px" }}
      >
        <thead>
          <tr>
            <th>ID</th>
            <th>Skill Details-ID</th>
            <th>Course</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {details.map((item) => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>
                {editId === item.id ? (
                  <input
                    value={formData.skill_id}
                    onChange={(e) =>
                      setFormData({ ...formData, skill_id: e.target.value })
                    }
                  />
                ) : (
                  item.skill_id
                )}
              </td>
              <td>
                {editId === item.id ? (
                  <input
                    value={formData.course}
                    onChange={(e) =>
                      setFormData({ ...formData, course: e.target.value })
                    }
                  />
                ) : (
                  item.course
                )}
              </td>
              <td>
                {editId === item.id ? (
                  <>
                    <button onClick={handleUpdate}>Save</button>
                    <button onClick={() => setEditId(null)}>Cancel</button>
                  </>
                ) : (
                  <>
                    <button
                      style={{
                        backgroundColor: "green",
                        color: "white",
                        padding: "6px 12px",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleEdit(item)}
                    >
                      Edit
                    </button>

                    <button
                      style={{
                        backgroundColor: "red",
                        color: "white",
                        padding: "6px 12px",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleDelete(item.id)}
                    >
                      Delete
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Subcatgoryview;
